import React, { useState } from "react";
import { Lightbulb, CaretDown } from "@phosphor-icons/react";
import LiveScoreStrip from "@/components/feature/LiveScoreStrip";

export default function PredictionCard({ pick, live, testIdPrefix = "prediction" }) {
    const [open, setOpen] = useState(false);
    const reasoning = (pick.reasoning || "").trim();
    return (
        <article
            className="group bg-card border border-border p-5 hover:border-primary/60 transition-snappy hover:-translate-y-0.5"
            data-testid={`${testIdPrefix}-card`}
        >
            <header className="mb-3">
                <h3
                    className="text-base font-bold tracking-tight text-white truncate"
                    data-testid={`${testIdPrefix}-match`}
                >
                    {pick.match || pick.matchName}
                </h3>
                {(pick.league || pick.leagueCountry) && (
                    <p className="text-xs font-mono uppercase tracking-wider text-zinc-500 mt-1 truncate">
                        {pick.league}
                        {pick.leagueCountry ? ` · ${pick.leagueCountry}` : ""}
                    </p>
                )}
            </header>
            <div className="border-t border-border pt-3 space-y-2">
                <div className="flex items-baseline justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                        Pick
                    </span>
                    <span
                        className="text-sm font-semibold text-primary text-right"
                        data-testid={`${testIdPrefix}-pick`}
                    >
                        {pick.prediction}
                    </span>
                </div>
                {pick.market && (
                    <div className="flex items-baseline justify-between">
                        <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                            Market
                        </span>
                        <span className="text-xs text-zinc-300 truncate ml-3">
                            {pick.market}
                        </span>
                    </div>
                )}
                <div className="flex items-baseline justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                        Odds
                    </span>
                    <span
                        className="font-mono text-base font-semibold text-white"
                        data-testid={`${testIdPrefix}-odds`}
                    >
                        {Number(pick.odds || 0).toFixed(2)}
                    </span>
                </div>
                <div className="flex items-baseline justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
                        Confidence
                    </span>
                    <span
                        className="font-mono text-sm font-semibold text-primary"
                        data-testid={`${testIdPrefix}-confidence`}
                    >
                        {pick.confidence}%
                    </span>
                </div>
            </div>

            <LiveScoreStrip pick={pick} live={live} testId={`${testIdPrefix}-live`} />

            {reasoning && (
                <div className="border-t border-border mt-3 pt-3">
                    <button
                        type="button"
                        onClick={() => setOpen((o) => !o)}
                        className="flex items-center justify-between w-full text-left group/why"
                        aria-expanded={open}
                        data-testid={`${testIdPrefix}-why-toggle`}
                    >
                        <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-primary group-hover/why:text-[#33FFB0]">
                            <Lightbulb size={11} weight="fill" />
                            Why this pick
                        </span>
                        <CaretDown
                            size={12}
                            weight="bold"
                            className={`text-primary transition-transform duration-200 ${
                                open ? "rotate-180" : ""
                            }`}
                        />
                    </button>
                    {open && (
                        <p
                            className="text-xs text-zinc-300 mt-2 leading-relaxed"
                            data-testid={`${testIdPrefix}-why-text`}
                        >
                            {reasoning}
                        </p>
                    )}
                </div>
            )}
        </article>
    );
}
